import React, { useState, useEffect, useRef } from 'react'
import { Button, Card, Col, Collapse, Modal, OverlayTrigger, Row, Spinner, Table, Tooltip } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { deleteNotification } from '../../service/api/notification/deleteNotification'
import { unreadNotificationCount } from '../../service/api/notification/unreadNotification'
import { setCurrentPage, setNotificationCount } from '../../feature/userData/userData'
import { singleNotification } from '../../service/api/notification/singleNotificationDetails'
import { userNotificationCount } from '../../service/api/notification/userNotification'
import AcceptRejectModal from '../../jsx/components/modalAcceptReject/modalAcceptreject';
import PaginationAndSearching from '../../component/paginationAndSearching/paginationAndSearching'
import SkeletonTableRow from '../../component/skeletonTableRow/skeletonTableRow'
import { errEmptyEmailOrPhone, txtNotifications, validEmail_OR_MobileNumberText } from '../../dataBaseFile/label'
import { bulkReadDeleteNotification } from '../../service/api/notification/bulkReadDelete'
import { getTickets } from '../../service/api/ticket/getTickets'
import { getCounterApi } from '../../service/api/ticket/serviceCounters'
import {
    setMyCurrentTab,
    setMyCurrentTabRedux,
} from "../../feature/serviceRequest/serviceRequestRedux";
import SkeletonDivElement from '../../component/skeletonTableRow/skeletonDivElement'
import { getCat } from '../../service/api/object/getCat'
import { getProductType } from '../../service/api/object/getProdType'
import SelectInputCategories from '../../jsx/components/fields/selectInputCategories'
import SelectInputProductTypes from '../../jsx/components/fields/selectInputProductTypes'
import InputField from '../../jsx/components/fields/inputField'
import TextArea from '../../jsx/components/fields/textArea'
import PrimaryButton from '../../jsx/components/button/primaryButton'
import EmailPhoneCombine from '../../jsx/components/fields/emailPhoneField'
import { emailValidation, noSpaceOnChange, phoneValidation } from '../../validations/validation'
import { apiGetRegisteredCompanies } from '../../service/api/companies/getRegisteredCompanies'
import SelectStateCompanies from '../../jsx/components/fields/selectStateCompanies'
import SelectPeriodFilter from '../../jsx/components/fields/selectPeriodFilter'

const ServiceLogs = () => {

    const { profilePicture, notificationCount, permissionArr } = useSelector((state) => state.user);
    const { myCurrentTab } = useSelector((state) => state.service);
    const permissionArray = permissionArr[0] || []
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [elements, setElements] = useState([])
    const [showThing, setShowThing] = useState(false)
    const [page, setPage] = React.useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [totalPage, setTotalPage] = useState(1)
    const [anchorEl, setAnchorEl] = React.useState(null)
    const [pageIndex, setPageIndex] = useState(1)
    const [nextDisabled, setNextDisabled] = useState(false)
    const [searchArea, setSearchArea] = useState("")
    const [loadingSkelton, setLoadingSekelton] = useState(false)
    const [bulkDeleteArr, setBulkDeleteArr] = useState([])
    const [flag, setFlag] = useState(false);
    const [notificationId, setNotificationId] = useState()
    const [basicModal, setBasicModal] = useState(false);
    const [indexOfId, setIndexOfId] = useState()
    const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);

    const [sortByValue, setSortByValue] = useState("DESC");
    const [searchValue, setSearchValue] = useState("");
    const [columnName, setColumnName] = useState("");

    const [counters, setCounters] = useState({});

    const [categoriesArr, setCategoriesArr] = useState([]);
    const [categoryName, setCategoryName] = useState("");
    const [filtersLoading, setFiltersLoading] = useState(false);
    const [filtersFirtLoading, setFiltersFirtLoading] = useState(true);

    const [isExpandedServiceId, setIsExpandedServiceId] = useState('');

    const [signInSignUpFilter, setSignInSignUpFilter] = useState(0);

    const [companiesList, setCompaniesList] = useState([])
    const [companyIdSuper, setCompanyIdSuper] = useState('')

    const [periodRangeFilter, setPeriodRangeFilter] = useState('6');
    const periodRangeArr = [
        { id: "6", name: "All" },
        { id: "1", name: "Last 7 days" },
        { id: "2", name: "Last 1 month" },
        { id: "3", name: "Last 3 months" },
        { id: "4", name: "Last 6 months" },
        { id: "5", name: "Last 1 year" },
    ]

    const handleGetCounters = () => {
        setFiltersLoading(true)
        let details = {
            scheduled_tickets_flag: 2,
            category_chr: categoryName,
            from_date_dtm: startDate,
            to_date_dtm: endDate,
            user_list_options: signInSignUpFilter,
            company_id_ids: companyIdSuper,
            period_options: periodRangeFilter ? periodRangeFilter : 0
        };
        dispatch(
            getCounterApi(
                details,
                (res) => {
                    setCounters(res.data);
                    setFiltersLoading(false);
                    setFiltersFirtLoading(false);
                    setCategoriesArr(res?.category_list)
                },
                (err) => {
                    setFiltersLoading(false);
                    setFiltersFirtLoading(false);
                }
            )
        );
    };

    useEffect(() => {
        handleGetCounters();
    }, [categoryName, signInSignUpFilter, companyIdSuper, periodRangeFilter]);









    // useEffect(() => {
    //     intialNotificationLoad()
    // }, [pageIndex, pageSize])
    const tooltip = (
        <Tooltip id="tooltip" >
            <strong >Delete</strong>
        </Tooltip>
    );
    const searchAreaVal = (e) => {
        // setSearchArea(e.target.value)
        // if (searchArea.trim().length >= 2) {
        //     onChangePage(1)
        // }

        setSearchValue(e.target.value)
        if (searchValue.trim().length >= 2) {
            onChangePage(1)
        }
    }


    const handleChangeRowsPerPage = (e) => {

        setSearchArea('')
        setPageIndex(1)
        setPageSize(e.target.value)

        setSearchValue('');
        setPage(1);


    }
    const onChangePage = (e, p) => {
        setPageIndex(e)
        setPage(e)
    }

    function onLoadSearch() {
        setLoadingSekelton(true)
        let details = {
            user_id_ids: localStorage.getItem('user_id'),
            page_index: 1,
            page_size: +pageSize,
            order: 'DESC',
            column_name: '',
            search_by: '',
            search_area: searchArea,
        }
        dispatch(
            userNotificationCount(
                details,
                (res) => {

                    setElements(res.data.data)
                    if (res.data.total_records % pageSize === 0) {
                        setTotalPage(parseInt(res.data.total_records / pageSize))
                    } else {
                        setTotalPage(parseInt(res.data.total_records / pageSize + 1))
                    }
                    setLoadingSekelton(false)
                    if (res.data.data.length === 0) {


                        setTimeout(() => {
                            setLoadingSekelton(false)
                        }, '3000')
                    }
                },
                () => {
                    setTimeout(() => {
                        setLoadingSekelton(false)
                    }, '3000')
                },
            ),
        )
    }
    useEffect(() => {

        // if (searchArea.trim().length > 2) {
        //     setFlag(true);
        //     const timeOutId = setTimeout(onLoadSearch, 1000);
        //     return () => clearTimeout(timeOutId);
        // } else if (searchArea.trim().length === 0) {
        //     if (flag) {
        //         onLoadSearch();
        //     }
        // }

        if (searchValue.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(() => { onLoadDataSearch(); handleGetCounters() }, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0) {
            if (flag) {
                onLoadDataSearch();
                handleGetCounters();
            }
        }

    }, [searchValue]);



    const [services, setServices] = useState([]);

    const onLoadData = () => {
        // setCustomeSkeletonLoading(true);
        setCustomeSkeletonLoading(true)
        let allTickets = new FormData();
        allTickets.append("page_index", page);
        allTickets.append("page_size", pageSize);
        allTickets.append("pagination_flag", 1);
        allTickets.append("sorting_order", sortByValue);
        allTickets.append("sorting_column_name", columnName);
        allTickets.append("search_area", searchValue);
        allTickets.append("category_chr", categoryName);
        startDate && allTickets.append("from_date_dtm", startDate);
        endDate && allTickets.append("to_date_dtm", endDate);
        allTickets.append("user_list_options", signInSignUpFilter);
        allTickets.append("company_id_ids", companyIdSuper);
        periodRangeFilter && allTickets.append("period_options", periodRangeFilter);
        // !permissionArray.includes("SCAN TAB") && allTickets.append("assigned_flag_ysn", 1);
        // permissionArray.includes("SCAN TAB") && allTickets.append("scheduled_tickets_flag", 2);


        myCurrentTab !== 1 &&
            allTickets.append(
                "ticket_status_int",
                (myCurrentTab == 2 && 2) ||
                (myCurrentTab == 3 && 9) ||
                (myCurrentTab == 4 && 7) ||
                (myCurrentTab == 5 && 8) ||
                (myCurrentTab == 6 && 10) ||
                (myCurrentTab == 7 && 12)
            );

        dispatch(
            getTickets(allTickets, (res) => {
                // console.log(res)
                getAllServicesData(res)
                setCustomeSkeletonLoading(false)
            }, (err) => {
                setCustomeSkeletonLoading(false)
            })
        );

        return;
    };

    useEffect(() => {
        onLoadData();
    }, [
        pageSize,
        columnName,
        myCurrentTab,
        page,
        categoryName,
        sortByValue,
        signInSignUpFilter,
        companyIdSuper,
        periodRangeFilter,
    ])

    const handleColumnName = (name) => {
        setColumnName(name)

        if (sortByValue === "ASC") {
            setSortByValue("DESC")
        }
        if (sortByValue === "DESC") {
            setSortByValue("ASC")
        }
    }

    const handleOrderValue = (order) => {

        setSortByValue(order)
    }

    function onLoadDataSearch() {
        let allTickets = new FormData();
        allTickets.append("page_index", page);
        allTickets.append("page_size", pageSize);
        allTickets.append("pagination_flag", 1);
        allTickets.append("sorting_order", sortByValue);
        allTickets.append("sorting_column_name", columnName);
        allTickets.append("search_area", searchValue);
        allTickets.append("category_chr", categoryName);
        startDate && allTickets.append("from_date_dtm", startDate);
        endDate && allTickets.append("to_date_dtm", endDate);
        allTickets.append("user_list_options", signInSignUpFilter);
        allTickets.append("company_id_ids", companyIdSuper);
        periodRangeFilter && allTickets.append("period_options", periodRangeFilter);
        // !permissionArray.includes("SCAN TAB") && allTickets.append("assigned_flag_ysn", 1);
        // permissionArray.includes("SCAN TAB") && allTickets.append("scheduled_tickets_flag", 2);


        myCurrentTab !== 1 &&
            allTickets.append(
                "ticket_status_int",
                (myCurrentTab == 2 && 2) ||
                (myCurrentTab == 3 && 9) ||
                (myCurrentTab == 4 && 7) ||
                (myCurrentTab == 5 && 8) ||
                (myCurrentTab == 6 && 10) ||
                (myCurrentTab == 7 && 12)
            );


        dispatch(
            getTickets(allTickets, (res) => {
                getAllServicesData(res);
            })
        );
    }

    const getAllServicesData = (res) => {
        setServices(res.data);

        if (res.total_count % pageSize === 0) {
            setTotalPage(parseInt(res.total_count / pageSize))
        } else {
            setTotalPage(parseInt(res.total_count / pageSize + 1))
        }
        setLoadingSekelton(false)
        if (res.data.length === 0) {
            setTimeout(() => {
                setLoadingSekelton(false)
            }, '3000')
        }
    }

    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const onRowClick = (e) => {
        localStorage.setItem("ticket_id", e?.ticket_id_ids);
        localStorage.setItem("ticket_display_name", e?.display_id_int);

        navigate("/serviceRequestDetails");
        // navigate("/serviceRequestDetailsCopy");
    };

    // Format the unix time in given format
    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? 'am' : 'pm';
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    // Assign service functions

    const [brandName, setBrandName] = useState("");
    const [modelNum, setModelNum] = useState("");
    const [serialNumber, setSerialNumber] = useState("");
    const [isDescrError, setIsDescrError] = useState(false);
    const [description, setDescription] = useState("");

    const [saveExpertiseName, setSaveExpertiseName] = useState('')
    const [catArr, setCatArr] = useState([]);
    const [prodTypeArr, setProdTypeArr] = useState([]);
    const [productType, setProductType] = useState("");

    // Modal trigger for the Update the service request
    const [assignServiceModalTrigger, setAssignServiceModalTrigger] = useState(false);
    const handleCloseAssignServiceModal = (e) => {
        e?.preventDefault();
        setAssignServiceModalTrigger(false);
        handleClearAssignServiceStates();
        // deleteAttachedImage1();
        // deleteAttachedImage2();
    };
    const handleShowAssignServiceModal = (e) => {
        setAssignServiceModalTrigger(true);
        getCategoriesData();
    }

    // Multiple attachments update service request
    const [selectedFileAttach, setSelectedFileAttach] = useState([]);
    const [selectedFileLimitAttach, setSelectedFileLimitAttach] = useState("");
    const [deleteIconVisiblityAttach, setDeleteIconVisiblityAttach] = useState({
        visibility: "hidden",
    });
    const hiddenFileInputAttach = useRef(0);

    const inputFileTargetAttach = (e) => {


        const selectedFileLengthAttach = [...selectedFileAttach];
        if (selectedFileLengthAttach.length < 3) {
            setDeleteIconVisiblityAttach({ visibility: "visible" });
            setSelectedFileAttach([...selectedFileAttach, e.target.files[0]]);

            return;
        }
        return setSelectedFileLimitAttach("*You can't add more than 3 files.")
    };

    const deleteUploadAttach = (fileIndex) => {
        const updatedFile = selectedFileAttach.filter((delElem, delElemIndex) => {
            return fileIndex !== delElemIndex;
        })
        setSelectedFileAttach([...updatedFile]);
        setSelectedFileLimitAttach("");

    };

    const handleAttachService = () => {
        hiddenFileInputAttach.current.click();
    };

    const handleBrandName = (e) => {
        // console.log(e.target.value);
        setBrandName(e.target.value);
    }

    const handleModelNumber = (e) => {
        // console.log(e.target.value);
        setModelNum(e.target.value);
    }

    const handleSerialNumber = (e) => {
        // console.log(e.target.value);
        setSerialNumber(e.target.value);
    }

    const handleDescription = (e) => {
        // console.log(e.target.value);
        setIsDescrError(false)
        setDescription(e.target.value);
    }

    const saveExpertiseNameFn = (e) => {
        // console.log(e.target.value, "-----------expertise name");
        setSaveExpertiseName(e.target.value);
        // console.log(e.target.value);

        // This code is for getting the product type based on the expertise name
        // catArr.map((element) => {
        //     if (element.category_id_ids === e.target.value) {
        //         // setSaveExpertiseName(element.category_name_chr);
        //         // console.log(element.category_name_chr)
        //         setforGettingProductType(element.category_id_ids);
        //     }
        // })
        // handleSetCatId(2)
    }

    const getCategoriesData = () => {
        var forCatData = {
            page_index: 1,
            page_size: 25,
            sorting_order: "ASC"
        };

        dispatch(
            getCat(forCatData, (res) => {
                setCatArr(res.data.data)
            }))
    }

    const getProductTypeByCatId = (ele) => {
        let data = {
            category_id_ids: ele.category_id_ids,
            page_size: 25,
        }
        dispatch(
            getProductType(
                data,
                (res) => {
                    setProdTypeArr(res.data.data);
                },
                (err) => {
                }
            )
        );
    }

    const handleChangeProductType = (e) => {
        setProductType(e.target.value);
        // console.log(e.target.value, "-----------hewrewr")
    };

    const handleAssignService = (e) => {
        e.preventDefault();

    }

    const handleClearAssignServiceStates = (e) => {
        setBrandName("");
        setModelNum("");
        setSerialNumber("");
        setDescription("");
        setSelectedFileAttach([]);
        setSaveExpertiseName('')
        setSelectedFileLimitAttach("");
        setProdTypeArr([]);
    }

    useEffect(() => {

        if (saveExpertiseName) {
            catArr?.map((element) => {
                if (element.category_name_chr === saveExpertiseName) {
                    getProductTypeByCatId(element);
                }
            })
        }

    }, [saveExpertiseName])

    const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
    const [emailPhoneValue, setEmailPhoneValue] = useState(localStorage.getItem("emailCompanyInvite") ? localStorage.getItem("emailCompanyInvite") : localStorage.getItem("phoneNumberCompanyInvite") ? localStorage.getItem("phoneNumberCompanyInvite") : "");
    const [codeValue, setCodeValue] = useState(localStorage.getItem("phoneCodeCompanyInvite") ? localStorage.getItem("phoneCodeCompanyInvite") : 1);
    const [isPhone, setIsPhone] = useState(false);
    const [loginErrorMsg, setLoginErrorMsg] = useState("");

    const handleEmailPhone = (e) => {
        // console.log(e.target.value);
        setIsEmailPhoneVal(false);
        noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);

    };

    const handleDropdownValue = (e) => {
        // setCodeValue(e.target.value);
        setCodeValue(e);

    };

    function handleBlur() {
        if (isPhone) {
            if (emailPhoneValue === "") {
                setIsEmailPhoneVal(true);
                setLoginErrorMsg(errEmptyEmailOrPhone);
            } else if (!phoneValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
                setLoginErrorMsg(validEmail_OR_MobileNumberText);
            }
        } else {
            if (emailPhoneValue === "") {
                setIsEmailPhoneVal(true);
                setLoginErrorMsg(errEmptyEmailOrPhone);
            } else if (!emailValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
                setLoginErrorMsg(validEmail_OR_MobileNumberText);
            }
        }
    }

    useEffect(() => {
        const dot = ".";
        const leng = emailPhoneValue.length - 1;
        if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
            if (emailPhoneValue.length < 11) {
                setIsPhone(true);
            } else {
                setIsPhone(false);
            }
        } else {
            setIsPhone(false);
        }
        if (emailPhoneValue === "") {
            setIsPhone(false);
        }
    }, [emailPhoneValue]);

    // Filters code here --------
    useEffect(() => {
        if (permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) {
            const getComapnies = new FormData();
            getComapnies.append("user_id_ids", localStorage.getItem("user_id"));
            getComapnies.append("pagination_flag", 0);
            // getComapnies.append("page_index", page);
            // getComapnies.append("page_size", pageSize);
            // getComapnies.append("sorting_order", sortByValue);
            // getComapnies.append("sorting_column_name", columnName);
            // getComapnies.append("search_area", searchValue);
            dispatch(
                apiGetRegisteredCompanies(getComapnies, (res) => {
                    // setElements(res.data.data);
                    const defaultCompany = { company_id_ids: '', company_name_chr: 'All' };
                    setCompaniesList([defaultCompany, ...res.data.data])
                }, (err) => { })
            );
        }
    }, [])

    const handlePeriodRangeFilter = (e) => {
        setPeriodRangeFilter(e.target.value);
    }

    function handleCompaniesSelectValue(e) {
        setCompanyIdSuper(e.target.value)
    }

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    // Using useRef for both date pickers
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);

    const handleStartDateClick = () => {
        startDateRef.current.showPicker();
    };

    const handleEndDateClick = () => {
        endDateRef.current.showPicker();
    };

    const handleStartDateChange = () => {
        // setStartDate(startDateRef.current.value);
        const selectedDate = startDateRef.current.value;
        const unixStartDate = Math.floor(new Date(selectedDate).getTime() / 1000);
        setStartDate(unixStartDate);
    };

    const handleEndDateChange = () => {
        // setEndDate(endDateRef.current.value);
        const selectedDate = endDateRef.current.value;
        const unixEndDate = Math.floor(new Date(selectedDate).getTime() / 1000);
        setEndDate(unixEndDate);
    };

    // console.log(startDate, "startDate", endDate, "endDate");

    const [isDatesClear, setIsDatesClear] = useState(false);
    const clearDatesFilter = () => {
        setStartDate(null);
        setEndDate(null);
        startDateRef.current.value = ''; // Clear the actual input field value
        endDateRef.current.value = ''; // Clear the actual input field value
        setIsDatesClear(prev => !prev)
        // onLoadData();

    }

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        onLoadData();
        handleGetCounters();
    }, [isDatesClear]);

    const [isMounted, setIsMounted] = useState(true);

    const clearAllFilters = () => {
        clearDatesFilter();
        setPeriodRangeFilter('6');
        setCompanyIdSuper('');
        setSearchValue('');
        setSignInSignUpFilter(0);

        setIsMounted(false);
        setTimeout(() => setIsMounted(true), 0);
    }

    const [downloadLogsLoading, setDownloadLogsLoading] = useState(false);
    const downloadLogsFn = () => {
        // setCustomeSkeletonLoading(true);
        setDownloadLogsLoading(true)
        let allTickets = new FormData();
        allTickets.append("page_index", page);
        allTickets.append("page_size", pageSize);
        allTickets.append("sorting_order", sortByValue);
        allTickets.append("sorting_column_name", columnName);
        allTickets.append("search_area", searchValue);
        allTickets.append("category_chr", categoryName);
        startDate && allTickets.append("from_date_dtm", startDate);
        endDate && allTickets.append("to_date_dtm", endDate);
        allTickets.append("user_list_options", signInSignUpFilter);
        allTickets.append("company_id_ids", companyIdSuper);
        periodRangeFilter && allTickets.append("period_options", periodRangeFilter);
        allTickets.append("download_report_flag", 1);

        myCurrentTab !== 1 &&
            allTickets.append(
                "ticket_status_int",
                (myCurrentTab == 2 && 2) ||
                (myCurrentTab == 3 && 9) ||
                (myCurrentTab == 4 && 7) ||
                (myCurrentTab == 5 && 8) ||
                (myCurrentTab == 6 && 10) ||
                (myCurrentTab == 7 && 12)
            );

        dispatch(
            getTickets(allTickets, (res) => {
                setDownloadLogsLoading(false)
                // console.log(res);
                const blob = new Blob([res], { type: 'text/csv;charset=utf-8;' });

                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `service_report_${new Date().toLocaleString().replace(/[^\w\s]/gi, '_')}.csv`); // Filename for download
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // Clean up
            }, (err) => {
                setDownloadLogsLoading(false)
            })
        );

        return;
    };

    return (
        <>
            <div className='row mx-0'>
                <div className='col-12  p-3'>

                    <div className="row mx-0 p-3">
                        <div className="col-lg-6 px-0 ps-2 d-flex align-item-center justify-content-start">
                            <span className="fs-4 fw-bold text-black">{"Services report"}</span>
                        </div>

                        <div className="col-lg-6 px-0 pe-2 d-flex align-item-center justify-content-end">


                            {/* {(permissionArray.includes("ASSIGN SERVICE REQUEST")) &&
                                <button
                                    onClick={(e) => {
                                        handleShowAssignServiceModal(e)
                                    }}
                                    className="admin-add-user px-3"
                                    style={{ width: 'auto' }}
                                    variant="light btn-rounded">

                                    <i
                                        className="bi bi-person-check"
                                        style={{ marginRight: "10px" }}></i>
                                    {"Assign service"}
                                </button>
                            } */}
                        </div>
                    </div>

                    {/* <div className='row mx-0'>
                        <div className='col-12  p-3'>
                            <span className="fs-4 fw-bold text-black">
                                {"Services"}
                            </span>
                        </div>
                    </div> */}

                    <div
                        className="row px-2 my-1 mb-3"
                        style={{
                            backgroundColor: "rgba(251, 252, 255, 1)",
                            // borderRadius: '16px',
                        }}
                    >
                        {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
                            <>
                                {
                                    <div className="row mx-0 mb-3 mt-2">
                                        <div className="col-12 px-0 d-flex align-item-center justify-content-end">

                                            <div
                                                className="d-flex flex-column shadow rounded-2 cursor-pointer bg-white me-3"
                                                style={{ width: '140px' }}
                                                onClick={(e) => { handleStartDateClick() }}
                                            >
                                                <div className="fs-7 d-flex justify-content-center align-items-center bg-primary rounded-top p-2 text-white font-w600">
                                                    <span className="me-2"><i className="bi bi-calendar-range"></i></span>
                                                    <span>{`Select start date`}</span>
                                                </div>
                                                <div className="d-flex justify-content-center align-items-center p-2">
                                                    <span className="font-w600 text-black">{
                                                        startDate ?
                                                            new Date(startDate * 1000).toLocaleDateString('en-US', {
                                                                month: 'short',
                                                                day: '2-digit',
                                                                year: 'numeric',
                                                            }) : '-'}</span>
                                                </div>

                                                {/* Hidden Input for Start Date */}
                                                <input
                                                    type="date"
                                                    ref={startDateRef}
                                                    onChange={handleStartDateChange}
                                                    max={new Date().toISOString().split('T')[0]}
                                                    // style={{ display: 'none' }}
                                                    style={{ visibility: 'hidden', width: '0', height: '0' }}
                                                />
                                            </div>

                                            <div
                                                className="d-flex flex-column shadow rounded-2 cursor-pointer bg-white"
                                                style={{ width: '140px' }}
                                                onClick={(e) => { handleEndDateClick() }}
                                            >
                                                <div className="fs-7 d-flex justify-content-center align-items-center bg-primary rounded-top p-2 text-white font-w600">
                                                    <span className="me-2"><i className="bi bi-calendar-range"></i></span>
                                                    <span>{`Select end date`}</span>
                                                </div>
                                                <div className="d-flex justify-content-center align-items-center p-2">
                                                    <span className="font-w600 text-black">{
                                                        endDate ?
                                                            new Date(endDate * 1000).toLocaleDateString('en-US', {
                                                                month: 'short',
                                                                day: '2-digit',
                                                                year: 'numeric',
                                                            }) : '-'}</span>
                                                </div>

                                                {/* Hidden Input for End Date */}
                                                <input
                                                    type="date"
                                                    ref={endDateRef}
                                                    onChange={handleEndDateChange}
                                                    max={new Date().toISOString().split('T')[0]}
                                                    // style={{ display: 'none' }}
                                                    style={{ visibility: 'hidden', width: '0', height: '0' }}
                                                />

                                            </div>

                                            {startDate && endDate &&
                                                <div className="d-flex align-items-center justify-content-center mx-2">
                                                    <div className="tooltipCustom">
                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Apply date"}</span>
                                                        <span
                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                            onClick={(e) => { onLoadData(); handleGetCounters(); }}
                                                            style={{ height: '40px', width: '40px', }}
                                                        >
                                                            <i className="bi bi-check2-circle text-success" style={{ color: 'green', fontSize: '25px' }} />
                                                        </span>
                                                    </div>
                                                </div>
                                            }

                                            {startDate && endDate &&
                                                <div className="d-flex align-items-center justify-content-center mx-2">
                                                    <div className="tooltipCustom">
                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Clear date filter"}</span>
                                                        <span
                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                            onClick={(e) => clearDatesFilter()}
                                                            style={{ height: '40px', width: '40px', }}
                                                        >
                                                            <i className="bi bi-x-circle text-danger" style={{ fontSize: '25px' }} />
                                                        </span>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }

                                {/* {
                                    <div className="row">

                                        <div className="col-6 col-md-3 pe-2 mb-2">
                                            <div
                                                className={`h-100 d-flex rounded p-2 cursor-pointer border-hovered ${signInSignUpFilter === 1 ? 'shadow-sm' : ''}`}
                                                style={{ border: signInSignUpFilter === 1 ? '2px solid orange' : '2px solid #c8c4c487' }}
                                                onClick={() => setSignInSignUpFilter(1)}
                                            >
                                                <div className="d-flex align-items-center">
                                                    <div className="me-2" style={{ fontSize: '40px' }}>
                                                        <i className="bi bi-person-fill"></i>
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <div className="mb-1"><span className="fs-5 font-w600 text-black">{"Pro initiated service"}</span></div>
                                                        <div><span className="fs-3 font-w600 text-black">{`${counters?.pro_initiated_service_request_count || 0}`}</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-6 col-md-3 mb-2">
                                            <div
                                                className={`h-100 d-flex rounded p-2 cursor-pointer border-hovered ${signInSignUpFilter === 2 ? 'shadow-sm' : ''}`}
                                                style={{ border: signInSignUpFilter === 2 ? '2px solid orange' : '2px solid #c8c4c487' }}
                                                onClick={() => setSignInSignUpFilter(2)}
                                            >
                                                <div className="d-flex align-items-center">
                                                    <div className="me-2" style={{ fontSize: '40px' }}>
                                                        <i className="bi bi-person-fill"></i>
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <div className="mb-1"><span className="fs-5 font-w600 text-black">{"Customer initiated service"}</span></div>
                                                        <div><span className="fs-3 font-w600 text-black">{`${counters?.customer_initiated_service_request_count || 0}`}</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                } */}

                                <div className="mt-4 d-flex justify-content-start row">
                                    {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
                                        <div className=" col-sm-3 pe-sm-2" style={{ width: '' }}>
                                            {isMounted && <SelectStateCompanies
                                                labelName={"Company"}
                                                options={companiesList}
                                                onChange={handleCompaniesSelectValue}
                                                defaultValue={companyIdSuper}
                                            />}
                                        </div>
                                    }


                                    {
                                        <div className="col-sm-3 pe-sm-2" style={{ width: '' }}>
                                            {isMounted && <SelectPeriodFilter
                                                labelName={`Filter by range`}
                                                onChange={(e) => handlePeriodRangeFilter(e)}
                                                defaultValue={periodRangeFilter}
                                                options={periodRangeArr}
                                                errorOccured={false}
                                                errorMessage={""}
                                            />}
                                        </div>
                                    }

                                    {
                                        <div className="col-md-6 col-12  pe-sm-2 d-flex" style={{ width: '' }}>
                                            <span
                                                className="px-3 py-1 cursor-pointer text-primary  font-w600 rounded overlay-action-btn bg-light d-flex align-items-center justify-content-center me-2"
                                                style={{ height: '40px' }}
                                                onClick={() => clearAllFilters()}
                                            >
                                                {`Clear all `}
                                            </span>

                                            <span
                                                className="px-3 py-1 cursor-pointer text-primary  font-w600 rounded overlay-action-btn bg-light d-flex align-items-center justify-content-center"
                                                style={{
                                                    height: '40px',
                                                    pointerEvents: downloadLogsLoading || services?.length == 0 ? 'none' : 'auto',
                                                    opacity: downloadLogsLoading || services?.length == 0 ? '0.5' : '1',
                                                }}
                                                onClick={() => { downloadLogsFn() }}
                                            >
                                                <span className="me-2" style={{ marginBottom: '2px' }}>
                                                    {downloadLogsLoading ?
                                                        <Spinner size="sm" /> :
                                                        <i class="bi bi-box-arrow-in-down"></i>
                                                    }
                                                </span>

                                                {`Download report`}
                                            </span>
                                        </div>
                                    }

                                </div>
                            </>
                        }

                        <div
                            className="row mx-0 my-3 align-items-center "
                            style={{ minHeight: "40px" }}
                        >

                            <div className="col-12 d-flex py-3 overflow-auto">

                                <span
                                    className=" d-flex align-items-center fs-6  position-relative me-3 font-w700 text-black"
                                    style={{
                                        height: "40px",
                                        width: '85px'
                                    }}
                                >
                                    {`Categories `}

                                </span>

                                {filtersLoading && filtersFirtLoading ?
                                    <span
                                        className='d-flex'
                                        style={{
                                            height: "40px",
                                        }}
                                    >
                                        {[...Array(4)].map((element, index) => {
                                            return (
                                                <SkeletonDivElement key={index} height={'40px'} width={'90px'} marginBottom={'5px'} marginRight={'5px'} borderRadius={'10px'} />
                                            )
                                        })}
                                    </span> :
                                    <>
                                        <span
                                            className=" d-flex align-items-center justify-content-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                            style={{
                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                fontWeight: "700",
                                                height: "40px",
                                                minWidth: '70px',
                                                backgroundColor: categoryName === '' ? "rgba(79, 93, 116, 1)" : "white",
                                                color: categoryName === '' ? "white" : "",
                                            }}
                                            onClick={() => {
                                                setCategoryName('');
                                            }}
                                        >
                                            {`All`}

                                            {counters?.total_service_requests_count > 0 && <span
                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                style={{
                                                    top: '-9px',
                                                    right: '2px',
                                                    background: 'rgba(131, 154, 192, 1)',
                                                }}
                                            >
                                                {`${counters?.total_service_requests_count || 0}`}
                                            </span>}
                                        </span>

                                        {categoriesArr?.length > 0 ?
                                            <>
                                                {categoriesArr?.map((element, index) => {
                                                    return (
                                                        <span
                                                            key={index}
                                                            className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                                            style={{
                                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                                fontWeight: "700",
                                                                height: "40px",
                                                                minWidth: 'max-content',
                                                                backgroundColor: element?.category_name_chr === categoryName ? "rgba(79, 93, 116, 1)" : "white",
                                                                color: element?.category_name_chr === categoryName ? "white" : "",
                                                            }}
                                                            onClick={() => {
                                                                setCategoryName(element?.category_name_chr);
                                                            }}
                                                        >
                                                            {element?.category_display_name_chr}

                                                            {element?.catergory_service_count > 0 && <span
                                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                                style={{
                                                                    top: '-9px',
                                                                    right: '2px',
                                                                    background: 'rgba(131, 154, 192, 1)',
                                                                }}
                                                            >
                                                                {`${element?.catergory_service_count || 0}`}
                                                            </span>}
                                                        </span>
                                                    )
                                                })}
                                            </> :
                                            <>
                                                <span
                                                    className='d-flex align-items-center'
                                                    style={{
                                                        height: "40px",
                                                    }}
                                                >
                                                    {`No categories`}
                                                </span>
                                            </>
                                        }
                                    </>
                                }


                            </div>

                            <div className="col-12 d-flex py-3 overflow-auto">

                                <span
                                    className=" d-flex align-items-center fs-6  position-relative me-3 font-w700 text-black"
                                    style={{
                                        height: "40px",
                                        width: '85px'
                                    }}
                                >
                                    {`Initiated by `}
                                </span>

                                {filtersLoading && filtersFirtLoading ?
                                    <span
                                        className='d-flex'
                                        style={{
                                            height: "40px",
                                        }}
                                    >
                                        {[...Array(4)].map((element, index) => {
                                            return (
                                                <SkeletonDivElement key={index} height={'40px'} width={'90px'} marginBottom={'5px'} marginRight={'5px'} borderRadius={'10px'} />
                                            )
                                        })}
                                    </span> :
                                    <>
                                        <span
                                            className=" d-flex align-items-center justify-content-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                            style={{
                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                fontWeight: "700",
                                                height: "40px",
                                                minWidth: '70px',
                                                backgroundColor: signInSignUpFilter === 0 ? "rgba(79, 93, 116, 1)" : "white",
                                                color: signInSignUpFilter === 0 ? "white" : "",
                                            }}
                                            onClick={() => {
                                                setSignInSignUpFilter(0);
                                            }}
                                        >
                                            {`All`}

                                            {counters?.all_initiated_service_request_count > 0 && <span
                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                style={{
                                                    top: '-9px',
                                                    right: '2px',
                                                    background: 'rgba(131, 154, 192, 1)',
                                                }}
                                            >
                                                {`${counters?.all_initiated_service_request_count || 0}`}
                                            </span>}
                                        </span>

                                        <span
                                            className=" d-flex align-items-center justify-content-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                            style={{
                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                fontWeight: "700",
                                                height: "40px",
                                                minWidth: '70px',
                                                backgroundColor: signInSignUpFilter === 1 ? "rgba(79, 93, 116, 1)" : "white",
                                                color: signInSignUpFilter === 1 ? "white" : "",
                                            }}
                                            onClick={() => {
                                                setSignInSignUpFilter(1);
                                            }}
                                        >
                                            {`Pro initiated service`}

                                            {counters?.pro_initiated_service_request_count > 0 && <span
                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                style={{
                                                    top: '-9px',
                                                    right: '2px',
                                                    background: 'rgba(131, 154, 192, 1)',
                                                }}
                                            >
                                                {`${counters?.pro_initiated_service_request_count || 0}`}
                                            </span>}
                                        </span>

                                        <span
                                            className=" d-flex align-items-center justify-content-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                            style={{
                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                fontWeight: "700",
                                                height: "40px",
                                                minWidth: '70px',
                                                backgroundColor: signInSignUpFilter === 2 ? "rgba(79, 93, 116, 1)" : "white",
                                                color: signInSignUpFilter === 2 ? "white" : "",
                                            }}
                                            onClick={() => {
                                                setSignInSignUpFilter(2);
                                            }}
                                        >
                                            {`Customer initiated service`}

                                            {counters?.customer_initiated_service_request_count > 0 && <span
                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                style={{
                                                    top: '-9px',
                                                    right: '2px',
                                                    background: 'rgba(131, 154, 192, 1)',
                                                }}
                                            >
                                                {`${counters?.customer_initiated_service_request_count || 0}`}
                                            </span>}
                                        </span>
                                    </>
                                }


                            </div>

                            <div className="col-12 d-flex py-3 overflow-auto">
                                <span
                                    className=" d-flex align-items-center fs-6  position-relative me-3 font-w700 text-black"
                                    style={{
                                        // border: "1px solid rgba(131, 154, 192, 1)",
                                        height: "40px",
                                        width: '85px'
                                    }}
                                >
                                    {`Status `}

                                </span>

                                {filtersLoading && filtersFirtLoading ?
                                    <span
                                        className='d-flex'
                                        style={{
                                            height: "40px",
                                        }}
                                    >
                                        {[...Array(4)].map((element, index) => {
                                            return (
                                                <SkeletonDivElement key={index} height={'40px'} width={'70px'} marginBottom={'5px'} marginRight={'5px'} borderRadius={'10px'} />
                                            )
                                        })}
                                    </span> :
                                    <>
                                        <span
                                            className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                            style={{
                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                fontWeight: "700",
                                                height: "40px",
                                                backgroundColor: myCurrentTab === 1 ? "rgba(79, 93, 116, 1)" : "white",
                                                color: myCurrentTab === 1 ? "white" : "",
                                            }}
                                            onClick={() => {
                                                dispatch(setMyCurrentTabRedux(1));
                                            }}
                                        >
                                            {`All requests`}

                                            {counters?.all_service_requests_count > 0 && <span
                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                style={{
                                                    top: '-9px',
                                                    right: '2px',
                                                    background: 'rgba(131, 154, 192, 1)',
                                                }}
                                            >
                                                {`${counters?.all_service_requests_count || 0}`}
                                            </span>}
                                        </span>

                                        <span
                                            className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                            style={{
                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                fontWeight: "700",
                                                height: "40px",
                                                backgroundColor: myCurrentTab === 5 ? "rgba(79, 93, 116, 1)" : "white",
                                                color: myCurrentTab === 5 ? "white" : "",
                                            }}
                                            onClick={() => {
                                                dispatch(setMyCurrentTabRedux(5));
                                            }}>
                                            {`Pending`}

                                            {counters?.pending_service_requests_count > 0 && <span
                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                style={{
                                                    top: '-9px',
                                                    right: '2px',
                                                    background: 'rgba(131, 154, 192, 1)',
                                                }}
                                            >
                                                {`${counters?.pending_service_requests_count || 0}`}
                                            </span>}
                                        </span>

                                        <span
                                            className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                            style={{
                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                fontWeight: "700",
                                                height: "40px",
                                                backgroundColor: myCurrentTab === 2 ? "rgba(79, 93, 116, 1)" : "white",
                                                color: myCurrentTab === 2 ? "white" : "",
                                            }}
                                            onClick={() => {
                                                dispatch(setMyCurrentTabRedux(2));
                                            }}>
                                            {`Active`}

                                            {counters?.in_progress_services_count > 0 && <span
                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                style={{
                                                    top: '-9px',
                                                    right: '2px',
                                                    background: 'rgba(131, 154, 192, 1)',
                                                }}
                                            >
                                                {`${counters?.in_progress_services_count || 0}`}
                                            </span>}
                                        </span>

                                        <span
                                            className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                            style={{
                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                fontWeight: "700",
                                                height: "40px",
                                                backgroundColor: myCurrentTab === 3 ? "rgba(79, 93, 116, 1)" : "white",
                                                color: myCurrentTab === 3 ? "white" : "",
                                            }}
                                            onClick={() => {
                                                dispatch(setMyCurrentTabRedux(3));
                                            }}>
                                            {`Closed`}

                                            {counters?.closed_services_count > 0 && <span
                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                style={{
                                                    top: '-9px',
                                                    right: '2px',
                                                    background: 'rgba(131, 154, 192, 1)',
                                                }}
                                            >
                                                {`${counters?.closed_services_count || 0}`}
                                            </span>}
                                        </span>

                                        <span
                                            className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                            style={{
                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                fontWeight: "700",
                                                height: "40px",
                                                backgroundColor: myCurrentTab === 4 ? "rgba(79, 93, 116, 1)" : "white",
                                                color: myCurrentTab === 4 ? "white" : "",
                                            }}
                                            onClick={() => {
                                                dispatch(setMyCurrentTabRedux(4));
                                            }}>
                                            {`Cancelled`}

                                            {counters?.cancelled_service_requests_count > 0 && <span
                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                style={{
                                                    top: '-9px',
                                                    right: '2px',
                                                    background: 'rgba(131, 154, 192, 1)',
                                                }}
                                            >
                                                {`${counters?.cancelled_service_requests_count || 0}`}
                                            </span>}
                                        </span>

                                        {(permissionArray.includes("UPDATE WORK INFORMATION") || permissionArray.includes("ASSIGN SERVICE REQUEST") || permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
                                            <span
                                                className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                                style={{
                                                    border: "1px solid rgba(131, 154, 192, 1)",
                                                    fontWeight: "700",
                                                    height: "40px",
                                                    backgroundColor: myCurrentTab === 6 ? "rgba(79, 93, 116, 1)" : "white",
                                                    color: myCurrentTab === 6 ? "white" : "",
                                                }}
                                                onClick={() => {
                                                    dispatch(setMyCurrentTabRedux(6));
                                                }}>
                                                {`Assign services`}

                                                {counters?.assigned_service_requests_count > 0 && <span
                                                    className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                    style={{
                                                        top: '-9px',
                                                        right: '2px',
                                                        background: 'rgba(131, 154, 192, 1)',
                                                    }}
                                                >
                                                    {`${counters?.assigned_service_requests_count || 0}`}
                                                </span>}
                                            </span>}

                                        <span
                                            className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                            style={{
                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                fontWeight: "700",
                                                height: "40px",
                                                backgroundColor: myCurrentTab === 7 ? "rgba(79, 93, 116, 1)" : "white",
                                                color: myCurrentTab === 7 ? "white" : "",
                                            }}
                                            onClick={() => {
                                                dispatch(setMyCurrentTabRedux(7));
                                            }}>
                                            {`Payment issues`}

                                            {counters?.payment_issue_service_requests_count > 0 && <span
                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                style={{
                                                    top: '-9px',
                                                    right: '2px',
                                                    background: 'rgba(131, 154, 192, 1)',
                                                }}
                                            >
                                                {`${counters?.payment_issue_service_requests_count || 0}`}
                                            </span>}
                                        </span>
                                    </>
                                }


                            </div>

                        </div>


                    </div>

                    <div className='my-3'>
                        <PaginationAndSearching
                            handleSearch={searchAreaVal}
                            // searchValue={searchArea}
                            searchValue={searchValue}
                            defaultValue={pageSize}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            totalCount={totalPage}
                            onChange={onChangePage}
                        />
                    </div>

                    <Table responsive>

                        <thead>
                            <tr className='text-black bg-light'>
                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("display_id_int") }}
                                >
                                    Service Id
                                    <span className="ml-1">
                                        {columnName === 'display_id_int' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>
                                <th
                                    // className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                // onClick={() => { handleColumnName("category_name_chr") }}
                                >
                                    Category
                                    {/* <span className="ml-1">
                                        {columnName === 'category_name_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span> */}
                                </th>
                                <th
                                    // className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                // onClick={() => { handleColumnName("created_by_name_chr") }}
                                >
                                    Created by
                                    {/* <span className="ml-1">
                                        {columnName === 'created_by_name_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span> */}
                                </th>
                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("amount_after_discount") }}
                                >
                                    Amount
                                    <span className="ml-1">
                                        {columnName === 'amount_after_discount' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>
                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("ticket_status_ysn") }}
                                >
                                    Status
                                    <span className="ml-1">
                                        {columnName === 'ticket_status_ysn' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>

                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("created_date_dtm") }}
                                >
                                    {`Created on`}
                                    <span className="ml-1">
                                        {columnName === 'created_date_dtm' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>

                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("problem_description_chr") }}
                                >
                                    Description
                                    <span className="ml-1">
                                        {columnName === 'problem_description_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            {customeSkeletonLoading ?
                                <SkeletonTableRow cols={8} /> :
                                <>
                                    {services?.length > 0 ?
                                        <>

                                            {services?.map((element, index) => {
                                                return (
                                                    <>
                                                        <tr
                                                            className={`notification-rows font-w700 ${isExpandedServiceId === element.ticket_id_ids ? "bg-primary text-white " : ""}`}
                                                            key={index}
                                                            onClick={() => {
                                                                // onRowClick(element)
                                                                if (element?.ticket_id_ids === isExpandedServiceId) {
                                                                    setIsExpandedServiceId('')
                                                                } else {
                                                                    setIsExpandedServiceId(element.ticket_id_ids)
                                                                }
                                                            }}
                                                        >
                                                            <td>
                                                                #{element.display_id_int}
                                                            </td>

                                                            <td>
                                                                {element.category_display_name_chr !== ("" || null) ?
                                                                    <span
                                                                        className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                        style={{
                                                                            background: "rgba(79, 93, 116, 1)",
                                                                        }}>
                                                                        {`${element.category_display_name_chr} ${((element.product_type_chr !== "null") && (element.product_type_chr !== null) && (element.product_type_chr !== "")) ? ` / ${element.product_type_chr}` : ''}`}
                                                                    </span> :
                                                                    <span
                                                                        className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                        style={{
                                                                            background: 'rgba(199, 212, 234, 1)'
                                                                        }}>
                                                                        {`No category`}
                                                                    </span>
                                                                }
                                                            </td>


                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <img
                                                                        // src={profilePicture}
                                                                        src={element?.avatar_url_chr}
                                                                        className={`rounded-lg me-2 ${element?.ticket_id_ids === isExpandedServiceId ? "border" : ""} rounded-3`}
                                                                        width="24"
                                                                        alt=""
                                                                    />{" "}
                                                                    <span className="w-space-no">{element.created_by_name_chr}</span>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                {`${USDollar.format((element?.amount_after_discount) || 0)}`}
                                                            </td>

                                                            <td>
                                                                <div>
                                                                    <div className="fs-7 border border-light px-3 py-1 rounded-pill bg-light" style={{ width: "fit-content" }}>
                                                                        <span
                                                                            className='font-w700'
                                                                            style={{
                                                                                color: (element.ticket_status_ysn === 0) ? "rgba(45, 204, 99, 1)" :
                                                                                    (element.ticket_status_ysn === 1 || element.ticket_status_ysn === 5) ? "blue" :
                                                                                        element.ticket_status_ysn === 2 ? "orange" :
                                                                                            (element.ticket_status_ysn === 4 || element.ticket_status_ysn === 6 || element.ticket_status_ysn === 7) ? "red" : '',
                                                                            }}
                                                                        >
                                                                            {element?.status_display_name_chr}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}

                                                                <span className="">{`${element?.created_date_dtm ?
                                                                    new Intl.DateTimeFormat("en-US", {
                                                                        year: "numeric",
                                                                        month: "short",
                                                                        day: "numeric",
                                                                        hour: 'numeric',
                                                                        minute: 'numeric',
                                                                        hour12: true
                                                                    }).format(
                                                                        element?.created_date_dtm * 1000
                                                                    ) : '-'}`}</span>
                                                            </td>

                                                            <td
                                                                className='text-truncate'
                                                                style={{
                                                                    maxWidth: '300px'
                                                                }}
                                                            >
                                                                {element.problem_description_chr ? element.problem_description_chr : "Problem description not specified"}
                                                            </td>

                                                            <td>
                                                                {/* <OverlayTrigger placement="top" overlay={tooltip}> */}
                                                                <div
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        if (element?.ticket_id_ids === isExpandedServiceId) {
                                                                            setIsExpandedServiceId('')
                                                                        } else {
                                                                            setIsExpandedServiceId(element.ticket_id_ids)
                                                                        }
                                                                    }}
                                                                    className="d-flex align-items-center justify-content-center bg-light rounded-3 overlay-action-btn text-black"
                                                                    style={{ fontSize: '15px', height: '30px', width: '35px' }}>
                                                                    {element?.ticket_id_ids === isExpandedServiceId ? <i class="bi bi-chevron-down"></i> : <i class="bi bi-chevron-right"></i>}
                                                                </div>
                                                                {/* </OverlayTrigger> */}
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td colSpan="8" className={`bg-light ${(element?.ticket_id_ids !== isExpandedServiceId) ? 'p-0' : ''}`}>
                                                                <Collapse
                                                                    in={element?.ticket_id_ids === isExpandedServiceId}
                                                                >
                                                                    <div className='row mx-0'>
                                                                        <div className='col-12 px-0'>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Created on`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}

                                                                                    <span className="">{`${element?.created_date_dtm ?
                                                                                        new Intl.DateTimeFormat("en-US", {
                                                                                            year: "numeric",
                                                                                            month: "short",
                                                                                            day: "numeric",
                                                                                            hour: 'numeric',
                                                                                            minute: 'numeric',
                                                                                            hour12: true
                                                                                        }).format(
                                                                                            element?.created_date_dtm * 1000
                                                                                        ) : '-'}`}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Updated on`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    {/* <span className="">{`${element?.updated_date_dtm ? formatUnixTimestamp(element?.updated_date_dtm) : '-'}`}</span> */}

                                                                                    <span className="">{`${element?.updated_date_dtm ?
                                                                                        new Intl.DateTimeFormat("en-US", {
                                                                                            year: "numeric",
                                                                                            month: "short",
                                                                                            day: "numeric",
                                                                                            hour: 'numeric',
                                                                                            minute: 'numeric',
                                                                                            hour12: true
                                                                                        }).format(
                                                                                            element?.updated_date_dtm * 1000
                                                                                        ) : '-'}`}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Last call`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    {/* <span className="">{`${element?.last_call_dtm ? formatUnixTimestamp(element?.last_call_dtm) : '-'}`}</span> */}

                                                                                    <span className="">{`${element?.last_call_dtm ?
                                                                                        new Intl.DateTimeFormat("en-US", {
                                                                                            year: "numeric",
                                                                                            month: "short",
                                                                                            day: "numeric",
                                                                                            hour: 'numeric',
                                                                                            minute: 'numeric',
                                                                                            hour12: true
                                                                                        }).format(
                                                                                            element?.last_call_dtm * 1000
                                                                                        ) : '-'}`}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Applied promocode`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className=" font-w600" style={{ color: "rgba(45, 204, 99, 1)" }}>{element.promo_code_applied_chr ? element.promo_code_applied_chr : "-"}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Amount received`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className=" font-w600" style={{ color: "rgba(45, 204, 99, 1)" }}>{`${USDollar.format((element?.amount_after_discount) || 0)}`}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Initiator`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="">
                                                                                        {element.created_by_name_chr ? element.created_by_name_chr : "-"}
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Updated by`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="">
                                                                                        {element.updated_by_chr ? element.updated_by_chr : "-"}
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Description`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="">
                                                                                        {element.problem_description_chr ? element.problem_description_chr : "Problem description not specified"}
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            {element?.image_urls?.length > 0 &&
                                                                                <div className='row mx-0 py-1 fs-6'>
                                                                                    <div className='col-4 px-0 '>
                                                                                        <span className="text-black font-w600">{`Attachments`}</span>
                                                                                    </div>
                                                                                    <div className='col-8 px-0 '>
                                                                                        {element?.image_urls?.map((element, index) => {
                                                                                            return (
                                                                                                <img
                                                                                                    key={index}
                                                                                                    src={element}
                                                                                                    className="rounded-3 border me-2"
                                                                                                    alt=''
                                                                                                    style={{ width: '50px', height: '50px', objectFit: 'contain', background: '#b2b0b0' }}
                                                                                                />
                                                                                            )
                                                                                        })}
                                                                                    </div>
                                                                                </div>
                                                                            }



                                                                        </div>
                                                                    </div>
                                                                </Collapse>
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            })}</> :
                                        <tr>
                                            <td colSpan="7">No Records Found</td>
                                        </tr>
                                    }
                                </>
                            }
                        </tbody>
                    </Table>



                </div>
            </div>

            {/* Modal for the update the service request */}

            <Modal className="fade" show={assignServiceModalTrigger}
                // onHide={handleClose} 
                centered
            >
                <Modal.Body>
                    <>
                        <div className='row mx-0'>
                            <div className='col-12 px-0'>

                                <div className='row mx-0'>
                                    <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                                        <span onClick={() => handleCloseAssignServiceModal()} className='cursor-pointer text-hovered'>
                                            <i className="bi bi-x-lg "></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0 mb-2'>
                                    <div className='fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black'>
                                        <span className=''>
                                            {/* {txtUpdateServiceRequest} */}
                                            {`Assign service request`}
                                        </span>
                                    </div>
                                </div>

                                {/* <div className='row mx-0'>
                                    <div className='col-12 px-0 d-flex align-items-center justify-content-center fs-5'>
                                        <span className=''>
                                            {`Fill in the main properties of the inventory item`}
                                        </span>
                                    </div>
                                </div> */}

                                <form className='mt-4'
                                    onSubmit={(e) => {
                                        handleAssignService(e)
                                    }}
                                >
                                    <div className='row mx-0 mb-2'>
                                        <div className='col-12 px-0'>
                                            <EmailPhoneCombine
                                                label={`Customer's Email or Phone number`}
                                                isEnteringNumber={isPhone}
                                                setIsEnteringNumber={setIsPhone}
                                                handleInputValue={handleEmailPhone}
                                                handleChangeCode={handleDropdownValue}
                                                errorOccured={isEmailPhoneVal}
                                                inputValue={emailPhoneValue}
                                                handleOnBlur={handleBlur}
                                                defaultCodeValue={codeValue}
                                                errorMessage={
                                                    // validEmail_OR_MobileNumberText
                                                    loginErrorMsg
                                                }
                                                isRequired={true}
                                            />
                                        </div>
                                    </div>


                                    <div className='row mx-0 mb-1'>
                                        <div className='col-12 px-0'>
                                            <SelectInputCategories
                                                labelName={`Select category`}
                                                onChange={(e) => saveExpertiseNameFn(e)}
                                                defaultValue={saveExpertiseName}
                                                options={catArr}
                                                errorOccured={false}
                                                errorMessage={"Please select category"}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0 mb-1'>
                                        <div className='col-12 px-0'>
                                            <SelectInputProductTypes
                                                labelName={"Select product type"}
                                                onChange={(e) => handleChangeProductType(e)}
                                                defaultValue={productType}
                                                options={prodTypeArr}
                                                errorOccured={false}
                                                errorMessage={"Please select product type"}
                                            // isForProdId={true}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0 mb-1'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                value={brandName}
                                                labelName={`Brand`}
                                                placeholderName={`Brand`}
                                                onChange={handleBrandName}
                                                onBlur={() => { }}
                                                errorOccured={false}
                                                errorMeesage={''}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0 mb-1'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                value={modelNum}
                                                labelName={`Model`}
                                                placeholderName={`Model`}
                                                onChange={handleModelNumber}
                                                onBlur={() => { }}
                                                errorOccured={false}
                                                errorMeesage={''}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0 mb-1'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                value={serialNumber}
                                                labelName={`Serial #`}
                                                placeholderName={`Serial #`}
                                                onChange={handleSerialNumber}
                                                onBlur={() => { }}
                                                errorOccured={false}
                                                errorMeesage={''}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <TextArea
                                                onChange={handleDescription}
                                                value={description}
                                                labelName={"Description"}
                                                errorOccured={isDescrError}
                                                errorMessage={"Please provide description"}
                                                rows={'3'}
                                                onBlur={() => { }}
                                            />
                                        </div>
                                    </div>



                                    <div className='row mx-0 mb-3'>
                                        <div className='col-12 px-0 d-flex align-items-center'>
                                            <div
                                                className='d-flex align-items-center justify-content-center cursor-pointer text-hovered fs-5 font-w600'
                                                onClick={() => { handleAttachService() }}
                                            >
                                                <span>
                                                    <i onClick={() => { }} className='bi bi-paperclip '></i>
                                                </span>
                                                <span className='ms-2'>
                                                    {`Attach file`}
                                                </span>
                                                <input
                                                    accept="image/*"
                                                    type="file"
                                                    multiple
                                                    style={{ display: "none" }}
                                                    ref={hiddenFileInputAttach}
                                                    onChange={(e) => {
                                                        inputFileTargetAttach(e);
                                                    }}
                                                />
                                            </div>
                                        </div>


                                        <div className='row mx-0 mb-2'>
                                            <div className='col-12 px-0'>
                                                <div className='text-danger'>
                                                    <span>{selectedFileLimitAttach}</span>
                                                </div>

                                                <div className='attachment-img-preview-bar justify-content-start'>
                                                    {selectedFileAttach?.map((previewFile, index) => {
                                                        return (
                                                            <span key={index} className='attachment-img-preview-span'>
                                                                <i onClick={() => deleteUploadAttach(index)} class="bi bi-x-circle attachment-img-preview-delete-icon"></i>
                                                                <img
                                                                    style={{ width: '40px', height: '50px', borderRadius: '5px' }}
                                                                    src={previewFile ? URL.createObjectURL(previewFile) : null}
                                                                    alt='Error'
                                                                />
                                                            </span>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <PrimaryButton
                                                onClick={(e) => {
                                                    handleAssignService(e)
                                                }}
                                                buttonName={'ASSIGN SERVICE'}
                                                type={"submit"}
                                                loadingMessage={'Saving...'}
                                                isLoading={false}
                                                style={{
                                                    width: '100%',
                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    borderRadius: '4px'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                </Modal.Body>
            </Modal>

        </ >
    )
}

export default ServiceLogs;